import React from 'react';
import { CentralProviderHeader, CentralProviderHeaderV3, CurrentLocationAvatar } from '@michelin/central-provider';
import { runningOnCanvas } from '@michelin/central-provider/dist/utils/canvas';
import { useUIVersion } from 'contexts/UIVersionContext';

export function Heading() {
  const { featureEnabled } = useUIVersion();

  const HeaderToRender = featureEnabled ? (
    <CentralProviderHeaderV3
      appTitle="Michelin"
      logoType="blueBackgroundPoweredByMichelin"
      customLink={
        <CurrentLocationAvatar allowedAccountTypes="fleet" allowedCountryCodes={['US', 'CA']} enableStateFiltering />
      }
      profileMenuItems={[]}
    />
  ) : (
    <CentralProviderHeader
      appTitle="Michelin"
      logoType="michelin"
      customLink={
        <CurrentLocationAvatar allowedAccountTypes="fleet" allowedCountryCodes={['US', 'CA']} enableStateFiltering />
      }
      profileMenuItems={[]}
    />
  );

  return (
    <>
      <div style={{ display: runningOnCanvas() ? 'none' : undefined }}>{HeaderToRender}</div>
    </>
  );
}
